module.exports = __webpack_public_path__ + "static/media/crp-scroll-right.3b3842fe.png";